import VideoCover from "../assets/serene-images/serene-construction.avif";

const generateGallery = (folderPath, count, extension = ".JPG") => {
  return Array.from({ length: count }, (_, i) => `${folderPath}/${i + 1}${extension}`);
};

export const sereneFeatures = [
  {
    title: "Construction Progress",
    cover: "/Serene-Construction-Progress/Images/Serene-September/1.JPG",
    type: "folder",
    folders: [
      {
        title: "September 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-September/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-September", 2, ".JPG"),
      },
      {
        title: "August 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-August/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-August", 2, ".JPG"),
      },
      {
        title: "July 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-July/1.jpg",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-July", 4, ".jpg"),
      },
      {
        title: "June 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-June/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-June", 20),
      },
      {
        title: "May 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-May/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-May", 16),
      },
      {
        title: "April 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-April/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-April", 15),
      },
      {
        title: "March 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-March/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-March", 15),
      },
      {
        title: "February 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-Feb/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-Feb", 8),
      },
      {
        title: "January 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-Jan/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-Jan", 6),
      },
      {
        title: "December 2025 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-Dec/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-Dec", 35),
      },
      {
        title: "November 2025 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-November/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-November", 3),
      }
    ]
  },
  {
    title: "Video Gallery",
    cover: VideoCover,
    type: "folder",
    folders: [
      {
        title: "September 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-September-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-September.mp4", title: "SEPTEMBER 2026 UPDATE" }
        ]
      },
      {
        title: "August 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-August-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-August.mp4", title: "AUGUST 2026 UPDATE" }
        ]
      },
      {
        title: "July 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-July-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-July.mp4", title: "JULY 2026 UPDATE" }
        ]
      },
      {
        title: "June 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-June/1.JPG",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-June.mp4", title: "JUNE 2026 UPDATE" }
        ]
      },
      {
        title: "May 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-May-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-May.mp4", title: "MAY 2026 UPDATE" }
        ]
      },
      {
        title: "April 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-April-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-April.mp4", title: "APRIL 2026 UPDATE" }
        ]
      },
      {
        title: "March 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-March-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-March.mp4", title: "MARCH 2026 UPDATE" }
        ]
      },
      {
        title: "February 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-February-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-February.mp4", title: "FEBRUARY 2026 UPDATE" }
        ],
      },
      {
        title: "January 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-January-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-January.mp4", title: "JANUARY 2026 UPDATE" }
        ],
      },
      {
        title: "December 2025 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-December-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-December.mp4", title: "DECEMBER 2025 UPDATE" }
        ]
      }
    ]
  },
];
